import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

export default function PageSidebar() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    loadPages();
  }, []);

  async function loadPages() {
    try {
      const q = query(
        collection(db, 'pages'),
        where('published', '==', true),
        where('showInNavigation', '==', true)
      );
      const snapshot = await getDocs(q);
      const pagesData = snapshot.docs.map(doc => ({
        id: doc.id,
        name: doc.data().title,
        href: `/${doc.data().slug}`
      }));
      // Sort alphabetically by name
      pagesData.sort((a, b) => a.name.localeCompare(b.name));
      setPages(pagesData);
    } catch (error) {
      console.error('Error loading pages:', error);
    }
  }

  return (
    <aside style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    }}>
      {/* Page Navigation Card */}
      <div className="card" style={{
        padding: '20px',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '700',
          marginBottom: '16px',
          color: 'var(--text)'
        }}>
          Quick Links
        </h3>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          {pages.map((page) => (
            <li key={page.id}>
              <a
                href={page.href}
                style={{
                  display: 'block',
                  padding: '8px 12px',
                  fontSize: '14px',
                  color: 'var(--text)',
                  textDecoration: 'none',
                  borderRadius: 'var(--radius-sm)',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = 'var(--bg)'}
                onMouseLeave={(e) => e.target.style.background = 'transparent'}
              >
                {page.name}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* CTA Card */}
      <div className="card" style={{
        padding: '24px',
        background: 'linear-gradient(135deg, var(--primary-light) 0%, var(--card) 100%)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '700',
          marginBottom: '12px',
          color: 'var(--text)'
        }}>
          Start Tracking Your Stats
        </h3>
        <p style={{
          fontSize: '14px',
          color: 'var(--muted)',
          lineHeight: '1.6',
          marginBottom: '16px'
        }}>
          Track your volleyball performance and improve your game with VBall Stats.
        </p>
        <a
          href="/?signup=true"
          style={{
            display: 'block',
            width: '100%',
            padding: '12px 20px',
            background: 'var(--primary)',
            color: 'white',
            textAlign: 'center',
            textDecoration: 'none',
            fontSize: '15px',
            fontWeight: '600',
            borderRadius: 'var(--radius-sm)',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = 'var(--primary-hover)'}
          onMouseLeave={(e) => e.target.style.background = 'var(--primary)'}
        >
          Get Started Free →
        </a>
      </div>
    </aside>
  );
}
